import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	fetchPrograms: ({ plantCd, urlSearchParams }) => {
		return client
			.get(`${BASE_URL}/program/v1/plants/${plantCd}/programs?${urlSearchParams}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchPlants: () => {
		return client
			.get(`${BASE_URL}/cc/v1/plant`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchShopCds: ({ plantCd }) => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=SHOP`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchServerNames: ({ plantCd }) => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=IOS`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchServiceKinds: ({ plantCd }) => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=SYSAREA`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchPgmTypes: ({ plantCd }) => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=PGMTYPE`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchLines: ({ plantCd }) => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=LINE`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchMainFlgs: ({ plantCd }) => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=MAINFLAG`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchExeEnvs: ({ plantCd }) => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=EXEENV`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchPgmIds: ({ plantCd, urlSearchParams }) => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${plantCd}/programs?${urlSearchParams}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	createProgram: ({ program }) => {
		const { plantCd, pgmId } = program;
		return client
			.post(`${BASE_URL}/program/v1/status/1/plants/${plantCd}/programs/${pgmId}`, program)
			.then(response => (response && response.data) || null)
			.catch(error => {
				// console.warn('DBGDBG createProgram ===> error');
				throw error;
			});
	},

	updateProgram: ({ program }) => {
		const { plantCd, pgmId } = program;
		return client
			.post(`${BASE_URL}/program/v1/status/2/plants/${plantCd}/programs/${pgmId}`, program)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	deleteProgram: ({ plantCd, pgmId }) => {
		const uri = `${BASE_URL}/program/v1/status/3/plants/${plantCd}/programs/${pgmId}`;
		const encoded = encodeURI(uri);
		return client
			.post(encoded)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	}
};
